import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  filterLoading: false,
  success: false,
  selectedRecord: null,
  assignmentData: null,
  assignmentLoading: true,
  companies: [],
  orgLevels: [],
  empLevels: [],
  organizations: [],
  positions: [],
  users: [],
  accessTypes: [],
  filteredOrganizations: [],
  positionGroupLevels: []
}

const fetchRoleStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchRoleSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    pagination: action.pagination,
    records: action.records
  }
}

const fetchRoleFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    errorMessage: action.errorMessage
  }
}

const fetchRoleByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData
  }
}

const clearSelectedRoleRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: null,
    success: false
  }
}

const createRoleStart = (state, action) => {
  return { ...state, loading: true }
}

const createRoleSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createRoleFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const assignRoleStart = (state, action) => {
  return { ...state, loading: true }
}

const assignRoleSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const assignRoleFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updateRoleStart = (state, action) => {
  return { ...state, loading: true }
}

const updateRoleSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updateRoleFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deleteRoleStart = (state, action) => {
  return { ...state, loading: true }
}

const deleteRoleSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deleteRoleFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    companies: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchRoleAssignmentDataStart = (state, action) => {
  return {
    ...state,
    assignmentLoading: true
  }
}

const fetchRoleAssignmentDataSuccess = (state, action) => {
  return {
    ...state,
    assignmentLoading: false,
    assignmentData: action.assignmentData
  }
}

const fetchRoleAssignmentDataFailed = (state, action) => {
  return {
    ...state,
    assignmentLoading: false,
    message: action.errorMessage
  }
}

const fetchEmpLevelOptionsStart = (state, action) => {
  return {
    ...state,
    assignmentLoading: true
  }
}

const fetchEmpLevelOptionsSuccess = (state, action) => {
  return {
    ...state,
    empLevels: action.data
    // assignmentLoading: false
  }
}

const fetchEmpLevelOptionsFailed = (state, action) => {
  return {
    ...state,
    message: action.errorMessage
  }
}

const fetchOrganizationOptionsStart = (state, action) => {
  return {
    ...state
    // assignmentLoading: true
  }
}

const fetchOrganizationOptionsSucess = (state, action) => {
  return {
    ...state,
    organizations: action.data
    // assignmentLoading: false
  }
}

const fetchOrganizationOptionsFailed = (state, action) => {
  return {
    ...state,
    message: action.errorMessage
  }
}

const fetchPositionOptionsStart = (state, action) => {
  return {
    ...state,
    assignmentLoading: true
  }
}

const fetchPositionOptionsSucess = (state, action) => {
  return {
    ...state,
    // assignmentLoading: false,
    positions: action.data
  }
}

const fetchPositionOptionsFailed = (state, action) => {
  return {
    ...state,
    // assignmentLoading: false,
    message: action.errorMessage
  }
}

const fetchOrgLevelOptionsStart = (state, action) => {
  return {
    ...state,
    assignmentLoading: true
  }
}

const fetchOrgLevelOptionsSucess = (state, action) => {
  return {
    ...state,
    // assignmentLoading: false,
    orgLevels: action.data
  }
}

const fetchOrgLevelOptionsFailed = (state, action) => {
  return {
    ...state,
    // assignmentLoading: false,
    message: action.errorMessage
  }
}

const fetchUserOptionsStart = (state, action) => {
  return {
    ...state,
    assignmentLoading: true
  }
}

const fetchUserOptionsSucess = (state, action) => {
  return {
    ...state,
    // assignmentLoading: false,
    users: action.data
  }
}

const fetchUserOptionsFailed = (state, action) => {
  return {
    ...state,
    // assignmentLoading: false,
    message: action.errorMessage
  }
}

const fetchAccessTypeOptionsStart = (state, action) => {
  return {
    ...state,
    assignmentLoading: true
  }
}

const fetchAccessTypeOptionsSuccess = (state, action) => {
  return {
    ...state,
    // assignmentLoading: false,
    accessTypes: action.data
  }
}

const fetchAccessTypeOptionsFailed = (state, action) => {
  return {
    ...state,
    // assignmentLoading: false,
    message: action.errorMessage
  }
}

const filterOrganizationOptionsStart = (state, action) => {
  return {
    ...state
    // assignmentLoading: true
  }
}

const filterOrganizationOptionsSuccess = (state, action) => {
  return {
    ...state,
    filteredOrganizations: action.data
  }
}

const filterOrganizationOptionsFailed = (state, action) => {
  return {
    ...state,
    message: action.errorMessage
  }
}

const fetchRoleOptionsStart = (state, action) => {
  return {
    ...state,
    filterLoading: true
  }
}

const fetchRoleOptionsSucess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    roles: action.data
  }
}

const fetchRoleOptionsFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchPositionGroupLevelOptionsStart = (state, action) => {
  return {
    ...state
  }
}

const fetchPositionGroupLevelOptionsSuccess = (state, action) => {
  return {
    ...state,
    positionGroupLevels: action.data
  }
}

const fetchPositionGroupLevelOptionsFailed = (state, action) => {
  return {
    ...state
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ROLE_START:
      return fetchRoleStart(state, action)
    case actionTypes.FETCH_ROLE_SUCCESS:
      return fetchRoleSuccess(state, action)
    case actionTypes.FETCH_ROLE_BY_ID_SUCCESS:
      return fetchRoleByIdSuccess(state, action)
    case actionTypes.FETCH_ROLE_FAILED:
      return fetchRoleFailed(state, action)
    case actionTypes.CLEAR_SELECTED_ROLE_RECORD:
      return clearSelectedRoleRecord(state, action)
    case actionTypes.CREATE_ROLE_START:
      return createRoleStart(state, action)
    case actionTypes.CREATE_ROLE_SUCCESS:
      return createRoleSuccess(state, action)
    case actionTypes.CREATE_ROLE_FAILED:
      return createRoleFailed(state, action)
    case actionTypes.ASSIGN_ROLE_START:
      return assignRoleStart(state, action)
    case actionTypes.ASSIGN_ROLE_SUCCESS:
      return assignRoleSuccess(state, action)
    case actionTypes.ASSIGN_ROLE_FAILED:
      return assignRoleFailed(state, action)
    case actionTypes.UPDATE_ROLE_START:
      return updateRoleStart(state, action)
    case actionTypes.UPDATE_ROLE_SUCCESS:
      return updateRoleSuccess(state, action)
    case actionTypes.UPDATE_ROLE_FAILED:
      return updateRoleFailed(state, action)
    case actionTypes.DELETE_ROLE_START:
      return deleteRoleStart(state, action)
    case actionTypes.DELETE_ROLE_SUCCESS:
      return deleteRoleSuccess(state, action)
    case actionTypes.DELETE_ROLE_FAILED:
      return deleteRoleFailed(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_ROLE_ASSIGNMENT_DATA_START:
      return fetchRoleAssignmentDataStart(state, action)
    case actionTypes.FETCH_ROLE_ASSIGNMENT_DATA_SUCCESS:
      return fetchRoleAssignmentDataSuccess(state, action)
    case actionTypes.FETCH_ROLE_ASSIGNMENT_DATA_FAILED:
      return fetchRoleAssignmentDataFailed(state, action)
    case actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_START:
      return fetchEmpLevelOptionsStart(state, action)
    case actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_SUCCESS:
      return fetchEmpLevelOptionsSuccess(state, action)
    case actionTypes.FETCH_EMPLOYEE_LEVEL_OPTIONS_FAILED:
      return fetchEmpLevelOptionsFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_START:
      return fetchOrganizationOptionsStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_SUCCESS:
      return fetchOrganizationOptionsSucess(state, action)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FAILED:
      return fetchOrganizationOptionsFailed(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_START:
      return fetchPositionOptionsStart(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_SUCCESS:
      return fetchPositionOptionsSucess(state, action)
    case actionTypes.FETCH_POSITION_OPTIONS_FAILED:
      return fetchPositionOptionsFailed(state, action)
    case actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_START:
      return fetchOrgLevelOptionsStart(state, action)
    case actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_SUCCESS:
      return fetchOrgLevelOptionsSucess(state, action)
    case actionTypes.FETCH_ORGANIZATION_LEVEL_OPTIONS_FAILED:
      return fetchOrgLevelOptionsFailed(state, action)
    case actionTypes.FETCH_USER_OPTIONS_START:
      return fetchUserOptionsStart(state, action)
    case actionTypes.FETCH_USER_OPTIONS_SUCCESS:
      return fetchUserOptionsSucess(state, action)
    case actionTypes.FETCH_USER_OPTIONS_FAILED:
      return fetchUserOptionsFailed(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_START:
      return fetchRoleOptionsStart(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_SUCCESS:
      return fetchRoleOptionsSucess(state, action)
    case actionTypes.FETCH_ROLE_OPTIONS_FAILED:
      return fetchRoleOptionsFailed(state, action)
    case actionTypes.FETCH_ACCESS_TYPE_OPTIONS_START:
      return fetchAccessTypeOptionsStart(state, action)
    case actionTypes.FETCH_ACCESS_TYPE_OPTIONS_SUCCESS:
      return fetchAccessTypeOptionsSuccess(state, action)
    case actionTypes.FETCH_ACCESS_TYPE_OPTIONS_FAILED:
      return fetchAccessTypeOptionsFailed(state, action)
    case actionTypes.FILTER_ORGANIZATION_OPTIONS_START:
      return filterOrganizationOptionsStart(state, action)
    case actionTypes.FILTER_ORGANIZATION_OPTIONS_SUCCESS:
      return filterOrganizationOptionsSuccess(state, action)
    case actionTypes.FILTER_ORGANIZATION_OPTIONS_FAILED:
      return filterOrganizationOptionsFailed(state, action)

    case actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_START:
      return fetchPositionGroupLevelOptionsStart(state, action)
    case actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_SUCCESS:
      return fetchPositionGroupLevelOptionsSuccess(state, action)
    case actionTypes.FETCH_POSITION_GROUP_LEVEL_OPTIONS_FAILED:
      return fetchPositionGroupLevelOptionsFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
